import type { FirehoseMessageDeps } from './firehose-message-deps.js';

export type FirehoseJsonMessage = Record<string, unknown>;

export type FirehoseMessageHandler = (msg: FirehoseJsonMessage, deps: FirehoseMessageDeps) => void;

export interface FirehoseMessageRouter {
  register(type: string, handler: FirehoseMessageHandler): void;
  dispatch(msg: FirehoseJsonMessage, deps: FirehoseMessageDeps): void;
}

export function createFirehoseMessageRouter(): FirehoseMessageRouter {
  const handlers = new Map<string, FirehoseMessageHandler>();

  return {
    register(type, handler) {
      handlers.set(type, handler);
    },
    dispatch(msg, deps) {
      const type = msg.type as string | undefined;
      if (!type) return;
      const handler = handlers.get(type);
      if (handler) handler(msg, deps);
    },
  };
}
